import type { ComponentProps, ReactNode } from 'react';

import { SectionLayoutBase } from '../../../common/section-layout-base.component';
import commonStyles from '../../../common/styles.module.scss';
import type { SectionIds } from './company-detail.presenter';
import { useSectionScrollObserverContext } from './company-detail.presenter';

export const SectionLayout = ({
  heading,
  children,
  id,
}: {
  heading: ComponentProps<typeof SectionLayoutBase>['heading'];
  children: ReactNode;
  id?: SectionIds;
}) => {
  const { sectionRefs } = useSectionScrollObserverContext();

  return (
    <SectionLayoutBase
      className={commonStyles.detailCompanySection}
      heading={heading}
      id={id}
      ref={
        id && sectionRefs.current
          ? (el) => {
              sectionRefs.current[id] = el;
            }
          : undefined
      }
    >
      {children}
    </SectionLayoutBase>
  );
};
